import { LogTransport, EnrichedLogEntry } from '../types';
import { LogLevel, levelLabel } from '../levels';

export class ConsoleTransport implements LogTransport {
  readonly name = 'console';

  send(entry: EnrichedLogEntry): void {
    try {
      const label = levelLabel(entry.level);
      const { message, ...context } = entry;
      const prefix = `[${label}] ${message}`;

      switch (entry.level) {
        case LogLevel.ERROR:
          console.error(prefix, context);
          break;
        case LogLevel.WARN:
          console.warn(prefix, context);
          break;
        case LogLevel.INFO:
          console.info(prefix, context);
          break;
        default:
          console.debug(prefix, context);
      }
    } catch {
      // never throw from transport
    }
  }
}
